import React from "react"
import { HashRouter } from "react-router-dom"

import { FrontendConfigDecorator } from "@cirrus/app-common/decorators/FrontendConfig"
import { StylesDecorator } from "@cirrus/app-common/decorators/StylesDecorator"
import { BasicTranslationsProvider } from "@cirrus/common/Translations/implementation/Basic"
import { buildDecorators } from "@cirrus/core/decorators"

import { Page } from "./Page"
import { CustomerSkinsDecorator } from "./providers/CustomerSkinsDecorator"
import { WithLoginPageFallback } from "./providers/Fallback"
import { HttpDecorator } from "./providers/HttpDecorator"
import { LoginServiceDecorator } from "./providers/LoginService/decorator"
import { WithAppNavigationService } from "./providers/NavigationService"
import { NewsDecorator } from "./providers/News/NewsDecorator"
import { WithSamlLoginBias } from "./providers/SamlLoginBias"
import { ThemeProviderDecorator } from "./providers/ThemeProviderDecorator"
import { CustomerInfoGuard } from "../CustomerInfo/CustomerInfoGuard"
import { LoginCustomerInfoProvider } from "../CustomerInfo/implementations/Login"

const StartPageDecorators = buildDecorators(

  FrontendConfigDecorator,
  HttpDecorator,
  HashRouter,
  WithAppNavigationService,
  LoginCustomerInfoProvider,
  CustomerInfoGuard,
  LoginServiceDecorator,
  WithSamlLoginBias,
  BasicTranslationsProvider,
  WithLoginPageFallback,
  ThemeProviderDecorator,
  StylesDecorator,
  CustomerSkinsDecorator,
  NewsDecorator,
  Page,
)

export const StartPageApp = () => (
  <StartPageDecorators />
)
